import { Form, Row } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import DatePickerComponent from 'components/atoms/DatePickerComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import FormWrapper from 'components/molecules/FormWrapper';

import { useDateLimit } from 'hooks/statniSprava/useDateLimit';
import { useFormBasics } from 'hooks/statniSprava/useFormBasics';

import AlertComponent from './AlertComponent';
import OdeslaniPozadavkuRows from './odeslaniPozadavkuRows';

interface IF3 {}

const F3: React.FC<IF3> = () => {
    const [form] = Form.useForm();
    const [, dateLoading] = useDateLimit();
    const [
        errMsg,
        currentStep,
        idSluzby,
        upozorneni,
        loading,
        odeslaniResp,
        setErrMsg,
        prev,
        onFormSubmit,
        showPxKlicLoadingMsg
    ] = useFormBasics();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onFinish = (fieldsValue: any) => {
        const dataToSend = {
            dtvp: fieldsValue.dtvp.format('YYYY-MM-DD')
        };
        onFormSubmit(dataToSend);
    };

    return (
        <LoadingWrapper loading={loading} loadingText={showPxKlicLoadingMsg ? 'LOADING_PXKLIC' : 'NACITANI'}>
            <Title level={4} text="DUVERNE_INFO_TITLE_F3" />{' '}
            {errMsg ? (
                <>
                    <Paragraph text={errMsg} />
                    <Row>
                        <ButtonComponent
                            type="default"
                            buttontext="ZPET"
                            onClick={() => setErrMsg('')}
                            id="f3ZpetBtn"
                        />
                    </Row>
                </>
            ) : (
                <>
                    {currentStep !== 2 ? (
                        <FormWrapper onFinish={onFinish} outForm={form}>
                            <LoadingWrapper loading={dateLoading}>
                                <DatePickerComponent
                                    name="dtvp"
                                    label="DUVERNE_INFO_POZADOVANY_DEN"
                                    disabled={currentStep > 0}
                                    disabledDate={current =>
                                        current < dayjs().subtract(11, 'days') || current >= dayjs().subtract(1, 'days')
                                    }
                                />
                            </LoadingWrapper>
                            {currentStep !== 0 && upozorneni && (
                                <AlertComponent upozorneni={upozorneni} type={currentStep === 1 ? 'error' : 'info'} />
                            )}
                            <Row className="button-row">
                                {currentStep === 1 && (
                                    <ButtonComponent
                                        buttontext="ZPET"
                                        onClick={() => prev()}
                                        type="default"
                                        id="f3ZpetAltBtn"
                                    />
                                )}
                                <ButtonComponent buttontext="ODESLAT" onClick={() => form.submit()} id="f3OdeslatBtn" />
                            </Row>
                        </FormWrapper>
                    ) : (
                        <>
                            <OdeslaniPozadavkuRows idSluzby={idSluzby} datum={odeslaniResp?.datum} />
                            {upozorneni && <AlertComponent upozorneni={upozorneni} type={'info'} />}
                        </>
                    )}{' '}
                </>
            )}
        </LoadingWrapper>
    );
};

export default F3;
